module.exports = __webpack_public_path__ + "static/media/male02.6329c094.jpg";